import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./proposal_form.css";
import AppTextField from "../../../component/app_text_field/app_text_field";
import AppSelectButton from "../../../component/app_select_button/app_select_button";

class MortgageDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            mortgageDetails: {
                financingInstitution: null,
                financingRefNo: null,
                financed: null,
                financingAmount: null,
                loanTerm: null,
                defermentPeriod: null,
                coverageTerm: null,
                benefit: null,
                criticalIllnessSumCovered: null,
                initialSumCovered: null,
                contributionAmount: null,
            },
            errorMessage: 'Fill in the required field.',
        };
    }

    initiateData() {
        let formData = this.props.value;
        let stateData = this.state.mortgageDetails;
        formData && Object.keys(formData).map(function (key) {
            stateData[key] = formData[key];
        })
        this.setState({ mortgageDetails: stateData })
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getFormFields() {
        return this.props.fields;
    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    async handleFormSubmit() {

    }


    financingInstitution() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.financingInstitution}
                type={'text'}
                disabled={true}
                value={this.state.mortgageDetails.financingInstitution}
            />
        )
    }
    financingRefNo() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.financingRefNo}
                type={'text'}
                disabled={true}
                value={this.state.mortgageDetails.financingRefNo}
            />
        )
    }
    financed() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.financed}
                disabled={true}
                value={this.state.mortgageDetails.financed}
            />
        )
    }
    financingAmount() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.financingAmount}
                type={'text'}
                prefix={'RM '}
                disabled={true}
                value={this.state.mortgageDetails.financingAmount}
            />
        )
    }
    loanTerm() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.loanTerm}
                type={'text'}
                disabled={true}
                value={this.state.mortgageDetails.loanTerm}
            />
        )
    }
    defermentPeriod() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.defermentPeriod}
                type={'text'}
                disabled={true}
                value={this.state.mortgageDetails.defermentPeriod}
            />
        )
    }
    coverageTerm() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.coverageTerm}
                type={'text'}
                disabled={true}
                value={this.state.mortgageDetails.coverageTerm}
            />
        )
    }
    benefit() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.benefit}
                type={'text'}
                prefix={'RM '}
                disabled={true}
                value={this.state.mortgageDetails.benefit}
            />
        )
    }
    criticalIllnessSumCovered() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.criticalIllnessSumCovered}
                type={'text'}
                prefix={'RM '}
                disabled={true}
                value={this.state.mortgageDetails.criticalIllnessSumCovered}
            />
        )
    }
    initialSumCovered() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.initialSumCovered}
                type={'text'}
                prefix={'RM '}
                disabled={true}
                value={this.state.mortgageDetails.initialSumCovered}
            />
        )
    }
    contributionAmount() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.mortgageFormTitle.contributionAmount}
                type={'text'}
                prefix={'RM '}
                disabled={true}
                value={this.state.mortgageDetails.contributionAmount}
            />
        )
    }


    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>

                <div className="w-100" >
                    <div className="">
                        <div className="section_title my-4">Representative’s Details</div>
                        <div className="row m-0 w-100" >
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.financingInstitution()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.financingRefNo()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.financed()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.financingAmount()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.loanTerm()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.defermentPeriod()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.coverageTerm()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.benefit()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.criticalIllnessSumCovered()}
                            </div>
                        </div> <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.initialSumCovered()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.contributionAmount()}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(MortgageDetails));
